import { App, PreviewImage, Image } from '@plone/volto/components';

// Register components.
export const components = {
  PreviewImage: { component: PreviewImage },
  App: { component: App },
  Image: { component: Image },
};
